import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Paging View Config"})
export default class PagingViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Show Numbers"})
	public showNumbers: boolean = true;

	@Input({type: InputType.NUMBER_POSITIVE, title: "Visible Page Numbers"})
	public visiblePageNumbers: number = 5;

	@Input({type: InputType.CHECKBOX, title: "Show Next/Prev"})
	public showNextPrev: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Show First/Last"})
	public showFirstLast: boolean = true;

	@Input({type: InputType.PADDING, title: "Button Padding"})
	public buttonPadding: string;

	@Input({type: InputType.BORDER, title: "Border"})
	public border: string;

	@Input({type: InputType.UNIT, title: "Border Radius"})
	public borderRadius: string;

	@Input({type: InputType.COLOR, title: "Background Color"})
	public backgroundColor: string;

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color: string;

	@Input({type: InputType.COLOR, title: "Hover Background Color"})
	public hoverBackgroundColor: string;

	@Input({type: InputType.COLOR, title: "Hover Text Color"})
	public hoverColor: string;

	@Input({type: InputType.COLOR, title: "Active Background Color"})
	public activeBackgroundColor: string;

	@Input({type: InputType.COLOR, title: "Active Text Color"})
	public activeColor: string;

	@Input({type: InputType.COLOR, title: "Disabled Background Color"})
	public disabledBackgroundColor: string;

	@Input({type: InputType.COLOR, title: "Disabled Text Color"})
	public disabledTextColor: string;

}



// WEBPACK FOOTER //
// ./src/common/views/paging/PagingViewConfig.ts